var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGoogleMobileEventClock = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 8,
  height: 8,
  viewBox: "0 0 8 8",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M4 0a4 4 0 1 1 0 8 4 4 0 0 1 0-8m.015 1.05-.174.005a2.967 2.967 0 0 0-2.791 2.96 2.967 2.967 0 0 0 2.965 2.964l.174-.005a2.967 2.967 0 0 0 2.791-2.96l-.005-.173a2.967 2.967 0 0 0-2.96-2.791m.47.597L4.5 3.75H6v1H3.5l-.006-3.103z"
})));
export default SvgGoogleMobileEventClock;